// extracted by mini-css-extract-plugin
export default {"menuItem":"whiteboard_menuItem__LRjUk"};